const WARNING_IN_BYTES = 5 * 1024 * 1024
const DANGER_IN_BYTES = 20 * 1024 * 1024
export default {
  methods: {
    formatBytes (bytes, size = 2, decimals = 2) {
      bytes = parseInt(bytes) || 0
      if (bytes === 0) return '0 Bytes'

      const k = 1000
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      return parseFloat((bytes / Math.pow(k, size)).toFixed(dm)) + ' ' + sizes[size]
    },

    sizeIndicator (bytes, warning = WARNING_IN_BYTES, danger = DANGER_IN_BYTES) {
      bytes = parseInt(bytes) || 0
      if (bytes < warning) {
        return 'success'
      } else if (bytes >= warning && bytes < danger) {
        return 'warning'
      } else {
        return 'danger'
      }
    }
  }
}
